<payee-popup
  [onCancel]="cancel"
  [onSubmit]="submit"
>
  <ng-template #payeePopupTitleTemplate>
    <h1>Szeretnéd, hogy a képviselők innentől a DNB-ből frissüljenek?</h1>
  </ng-template>
  <ng-template #payeePopupDescriptionTemplate></ng-template>
</payee-popup>
